import { IConversationAuthClient, ITokenResponse } from "@auvious/integrations";
import { sessionStore } from "@auvious/utils";
import { AppConfigService } from "./app.config.service";
import { Log } from "./log.service";
import {
  DigitalConnectAuthClient,
  GenesysWebMessagingAuthClient,
  NoAuthClient,
} from "../models";
import { AuviousCommon } from "@auvious/common";
import { CommonService } from "./common.service";

class ConversationAuthServiceCtrl {
  private _authClient: IConversationAuthClient;
  private _authToken: string;
  private _commonClient: AuviousCommon;

  public get common(): AuviousCommon {
    return this._commonClient;
  }

  async init() {
    this._commonClient = await CommonService.createInstance();
    switch (AppConfigService.chatMode) {
      case "talkdesk-digital-connect":
        this._authClient = new DigitalConnectAuthClient(this._commonClient);
        break;
      case "genesys-web-messaging":
        this._authClient = new GenesysWebMessagingAuthClient();
        break;
      default:
        this._authClient = new NoAuthClient();
        break;
    }
  }

  public async destroy() {
    await CommonService.logout(this._commonClient);
    this._commonClient = undefined;
  }

  public get client(): IConversationAuthClient {
    return this._authClient;
  }

  public setAuthenticatedSessionCode(token: string) {
    this._authToken = token;
  }

  public getAuthenticatedSessionCode(): string {
    return this._authToken;
  }
}

export const ConversationAuthService = new ConversationAuthServiceCtrl();

export class OAuth2TokenHelper {
  public static saveToken(key, token) {
    try {
      sessionStore.setItem(key, JSON.stringify(token));
    } catch {}
  }

  public static removeToken(key) {
    sessionStore.removeItem(key);
  }

  public static getToken(key): ITokenResponse {
    let token: ITokenResponse;
    try {
      token = JSON.parse(sessionStore.getItem(key));
    } catch {
      token = null;
    }
    return token;
  }

  public static isTokenExpired(token: ITokenResponse): boolean {
    try {
      const accessTokenObj = JSON.parse(
        atob(token.access_token.split(".")[1])
      ) as any;

      // if exp is missing then we have a non-expired token
      if (!accessTokenObj.exp) {
        Log.debug("non-expiring token detected!");
        return false;
      }

      return Date.now() > 1000 * accessTokenObj.exp;
    } catch (error) {
      Log.debug("error while checking token expiration: token", token, error);
    }

    return true;
  }

  public static isRefreshTokenExpired(token: ITokenResponse): boolean {
    try {
      // refresh token is now a short code and not base64, so we just check if it exists
      return !token.refresh_token;
    } catch (error) {
      Log.debug("error while checking token expiration", error);
    }

    return true;
  }
}
